import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesAddressCreateMain } from './modules/ui/Main';

const AddressCreatePage = (
  <SuspensePage>
    <PagesAddressCreateMain />
  </SuspensePage>
);

export default AddressCreatePage;
